import { transform, isEqual, isObject } from 'lodash-es';
export function objectDifference(object, base) {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      result[key] = isObject(value) && isObject(base[key]) ? objectDifference(value, base[key]) : value;
    }
  });
}
